  <div class="form-group">
  <div  class="form-group required-field">
    <label>Kurs-ID:</label>
    <span>{{ course.courseId }}</span>
  </div>

  <div  class="form-group required-field">
    <label>Kursname:</label>
    <span>{{ course.courseName }}</span>
  </div>

  <div  class="form-group required-field">
    <label>Startdatum:</label>
    <span>{{ course.startDate | date : "dd.MM.yyyy" }}</span>
  </div>

  <div  class="form-group required-field" *ngIf="course.endDate">
    <label>Enddatum:</label>
    <span>{{ course.endDate | date : "dd.MM.yyyy" }}</span>
  </div>

  <div class="p-field">
    <label>Status:</label>
    <span>{{ course.isActive ? "Aktiv" : "Inaktiv" }}</span>
  </div>

  <div  class="form-group required-field" *ngIf="course.ihk">
    <label>IHK:</label>
    <span>{{ course.ihk }}</span>
  </div>

  <div  class="form-group required-field" *ngIf="course.courseType">
    <label>Kursart:</label>
    <span>{{ course.courseType.courseTypeName }}</span>
  </div>

   <div  class="form-group required-field" *ngIf="course.location">
    <label>Ort:</label>
    <span>{{ course.location.locationName }}</span>
  </div>

  <div  class="form-group required-field" *ngIf="getTeilnehmer().length > 0">
    <label>Teilnehmer:</label>
    <ul class="teilnehmer-list">
      <li *ngFor="let user of getTeilnehmer()">{{ user.fullName }}</li>
    </ul>
  </div>
</div>
